// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x0s6D","largestCol":"styles_largestCol__q71NR","smallestCol":"styles_smallestCol__8ymA4"};